// Dev-only diagnostics: silent in production builds so nothing leaks to users.
const isDev = process.env.NODE_ENV !== "production";

export const logError = (context, error) => {
  if (isDev) console.error(`[${context}]`, error);
};
